var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"success-header"},[_c('div',{staticClass:"success-header__row",on:{"click":function($event){return _vm.dataLayerPush()}}},[_c('img',{staticClass:"success-header__logo",attrs:{"src":require('@/assets/img/success-ladder/Logotype.svg'),"alt":"herbalife logo"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }